import { z } from 'zod';

/**
 * Schéma de la charge utile envoyée à la création d'un projet.
 *
 * Il décrit l'objet construit par handleSubmit dans AjouterProjet, pas l'état
 * interne du formulaire : les clés correspondent donc à la fois aux champs de
 * l'API et aux attributs name des inputs, ce qui permet de rattacher chaque
 * message d'erreur à son champ sans table de correspondance.
 *
 * Les messages sont des clés de traduction (cf. dictionnaire.json), résolues
 * par checkMot au moment de l'affichage.
 */
export const schemaNouveauProjet = z.object({
  // Seul champ marqué required dans le formulaire aujourd'hui.
  project_name: z
    .string({ message: 'saisir_un_nom_de_projet' })
    .trim()
    .min(1, { message: 'saisir_un_nom_de_projet' }),

  // null quand aucun projet parent n'est sélectionné.
  parent_id: z.number({ message: 'valeur_invalide' }).int().nullable(),

  // Chaîne vide = champ non renseigné, cas courant et accepté aujourd'hui.
  // Toute autre valeur non tableau est une saisie invalide.
  geo_barr: z.union([z.array(z.any()), z.literal('')], {
    message: 'format_geo_barriere_attendu',
  }),

  groupe: z.string({ message: 'valeur_invalide' }),
  description: z.string({ message: 'valeur_invalide' }),

  // Alimenté par FormulaireAjoutUtilisateursAProjet ; contenu non contraint
  // tant que le format des identifiants n'a pas été vérifié.
  users_list_id: z.array(z.any(), { message: 'valeur_invalide' }),

  active: z.union([z.literal(0), z.literal(1)], { message: 'valeur_invalide' }),
});

/**
 * Schéma de la charge utile envoyée à la modification d'un projet.
 *
 * Même contrat que la création, plus l'identifiant du projet visé : le schéma
 * de création est donc étendu plutôt que recopié, pour que toute règle ajoutée
 * à l'un s'applique automatiquement à l'autre.
 */
export const schemaModificationProjet = schemaNouveauProjet.extend({
  project_id: z.number({ message: 'valeur_invalide' }).int(),
});
